import { ThemeProvider } from "@material-ui/core";
import React, { createContext, useContext, useReducer } from "react";
import getTheme from "themes";

let ThemeStateContext = createContext();
let ThemeDispatchContext = createContext();

const AVAILABLE_THEMES = ["dark", "light", "black"];
function themeReducer(state, action) {
  switch (action.type) {
    case "TOGGLE_THEME":
      localStorage.setItem("appTheme", action.payload);
      return { ...state, appTheme: action.payload, id: action.id };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

const CustomThemeProvider = ({ children }) => {
  const localTheme=localStorage.getItem("appTheme");
  let [state, dispatch] = useReducer(themeReducer, {
    appTheme: localTheme || "dark",
    id: null
  });

  return (
    <ThemeStateContext.Provider value={state}>
      <ThemeDispatchContext.Provider value={dispatch}>
        <ThemeProvider theme={getTheme(state.appTheme)}>
          {children}
        </ThemeProvider>
      </ThemeDispatchContext.Provider>
    </ThemeStateContext.Provider>
  );
};

const useThemeState = () => {
  var context = useContext(ThemeStateContext);
  if (context === undefined) {
    throw new Error("useThemeState must be used within a CustomThemeProvider");
  }
  return context;
};

const useThemeDispatch = () => {
  var context = useContext(ThemeDispatchContext);
  if (context === undefined) {
    throw new Error(
      "useThemeDispatch must be used within a ThemeSwticherProvider",
    );
  }
  return context;
};

export { CustomThemeProvider, useThemeState, useThemeDispatch, toggleTheme, setTheme };

const toggleTheme = dispatch => {
  const prevTheme = localStorage.getItem("appTheme");
  let themeIndex = AVAILABLE_THEMES.indexOf(prevTheme);
  let nextTheme = "";
  if (themeIndex + 1 >= AVAILABLE_THEMES.length) themeIndex = 0;
  else themeIndex++;
  nextTheme = AVAILABLE_THEMES[themeIndex];
  console.log("nextTheme", nextTheme);
  dispatch({
    type: "TOGGLE_THEME",
    payload: nextTheme,
  });
};

const setTheme = (dispatch, themePreference) => {
  dispatch({
    type: "TOGGLE_THEME",
    payload: themePreference.value,
    id: themePreference.id
  });
};


